// Inspiration: https://github.com/microsoft/TypeScript/issues/31474
export type ExtractStrict<T, U extends T> = T extends U ? T : never;
